import React from "react";
import { Clock, AlertTriangle, CheckCircle } from "lucide-react";
import "../../styles/deadlinebadge.css";

export default function DeadlineBadge({ dateString }) {
  if (!dateString) return null;

  const dueDate = new Date(dateString);
  const now = new Date();
  const diffMs = dueDate - now;
  const diffHrs = diffMs / (1000 * 60 * 60);
  const diffDays = diffHrs / 24;

  let status = "";
  let bg = "";
  let Icon = null;
  let text = "";

  if (diffHrs < 0) {
    status = "overdue";
    bg = "overdue";
    // Icon = Clock;
    Icon = <Clock size={16} />;
    text = "Overdue";
  } else if (diffHrs <= 24) {
    status = "soon";
    bg = "soon";
    // Icon = AlertTriangle;
    Icon = (
      <svg
        width={17}
        height={16}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5 9.83333C8.22667 9.83333 8 9.60667 8 9.33333V6C8 5.72667 8.22667 5.5 8.5 5.5C8.77333 5.5 9 5.72667 9 6V9.33333C9 9.60667 8.77333 9.83333 8.5 9.83333Z"
          fill="white"
        />
        <path
          d="M8.49967 11.9991C8.45967 11.9991 8.41301 11.9924 8.36634 11.9857C8.32634 11.9791 8.28634 11.9657 8.24634 11.9457C8.20634 11.9324 8.16634 11.9124 8.12634 11.8857C8.09301 11.8591 8.05967 11.8324 8.02634 11.8057C7.90634 11.6791 7.83301 11.5057 7.83301 11.3324C7.83301 11.1591 7.90634 10.9857 8.02634 10.8591C8.05967 10.8324 8.09301 10.8057 8.12634 10.7791C8.16634 10.7524 8.20634 10.7324 8.24634 10.7191C8.28634 10.6991 8.32634 10.6857 8.36634 10.6791C8.45301 10.6591 8.54634 10.6591 8.62634 10.6791C8.67301 10.6857 8.71301 10.6991 8.75301 10.7191C8.79301 10.7324 8.83301 10.7524 8.87301 10.7791C8.90634 10.8057 8.93967 10.8324 8.97301 10.8591C9.09301 10.9857 9.16634 11.1591 9.16634 11.3324C9.16634 11.5057 9.09301 11.6791 8.97301 11.8057C8.93967 11.8324 8.90634 11.8591 8.87301 11.8857C8.83301 11.9124 8.79301 11.9324 8.75301 11.9457C8.71301 11.9657 8.67301 11.9791 8.62634 11.9857C8.58634 11.9924 8.53967 11.9991 8.49967 11.9991Z"
          fill="white"
        />
        <path
          d="M12.54 14.7732H4.45998C3.15998 14.7732 2.16665 14.2999 1.65998 13.4466C1.15998 12.5932 1.22665 11.4932 1.85998 10.3532L5.89998 3.08656C6.56665 1.88656 7.48665 1.22656 8.49998 1.22656C9.51332 1.22656 10.4333 1.88656 11.1 3.08656L15.14 10.3599C15.7733 11.4999 15.8466 12.5932 15.34 13.4532C14.8333 14.2999 13.84 14.7732 12.54 14.7732ZM8.49998 2.22656C7.87332 2.22656 7.25998 2.70656 6.77332 3.57323L2.73998 10.8466C2.28665 11.6599 2.21332 12.4066 2.52665 12.9466C2.83998 13.4866 3.53332 13.7799 4.46665 13.7799H12.5466C13.48 13.7799 14.1666 13.4866 14.4866 12.9466C14.8066 12.4066 14.7266 11.6666 14.2733 10.8466L10.2267 3.57323C9.73998 2.70656 9.12665 2.22656 8.49998 2.22656Z"
          fill="white"
        />
      </svg>
    );
    const hoursLeft = Math.floor(diffHrs);
    // text = ` At Risk - ${hoursLeft} hour${hoursLeft !== 1 ? "s" : ""}`;
    text = (
      <>
        {hoursLeft}
        hour{hoursLeft !== 1 ? "s" : ""} left
      </>
    );
  } else if (diffHrs <= 48) {
    status = "upcoming";
    bg = "upcoming";
    // Icon = CheckCircle;
    Icon = (
      <svg
        width={17}
        height={16}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.49967 15.1654C4.54634 15.1654 1.33301 11.952 1.33301 7.9987C1.33301 4.04536 4.54634 0.832031 8.49967 0.832031C12.453 0.832031 15.6663 4.04536 15.6663 7.9987C15.6663 11.952 12.453 15.1654 8.49967 15.1654ZM8.49967 1.83203C5.09967 1.83203 2.33301 4.5987 2.33301 7.9987C2.33301 11.3987 5.09967 14.1654 8.49967 14.1654C11.8997 14.1654 14.6663 11.3987 14.6663 7.9987C14.6663 4.5987 11.8997 1.83203 8.49967 1.83203Z"
          fill="white"
        />
        <path
          d="M7.55297 10.3877C7.41964 10.3877 7.29297 10.3344 7.19964 10.241L5.31297 8.35437C5.11964 8.16104 5.11964 7.84104 5.31297 7.64771C5.5063 7.45438 5.8263 7.45438 6.01964 7.64771L7.55297 9.18104L10.9796 5.75438C11.173 5.56104 11.493 5.56104 11.6863 5.75438C11.8796 5.94771 11.8796 6.26771 11.6863 6.46104L7.9063 10.241C7.81297 10.3344 7.6863 10.3877 7.55297 10.3877Z"
          fill="white"
        />
      </svg>
    );
    const hoursLeft = Math.floor(diffHrs);
    // text = ` On Track -${hoursLeft} hour${hoursLeft !== 1 ? "s" : ""} left`;
    text = (
      <>
        {hoursLeft} hour{hoursLeft !== 1 ? "s" : ""} left
      </>
    );
  } else {
    status = "upcoming";
    bg = "upcoming";
    // Icon = CheckCircle;
    Icon = (
      <svg
        width={17}
        height={16}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.49967 15.1654C4.54634 15.1654 1.33301 11.952 1.33301 7.9987C1.33301 4.04536 4.54634 0.832031 8.49967 0.832031C12.453 0.832031 15.6663 4.04536 15.6663 7.9987C15.6663 11.952 12.453 15.1654 8.49967 15.1654ZM8.49967 1.83203C5.09967 1.83203 2.33301 4.5987 2.33301 7.9987C2.33301 11.3987 5.09967 14.1654 8.49967 14.1654C11.8997 14.1654 14.6663 11.3987 14.6663 7.9987C14.6663 4.5987 11.8997 1.83203 8.49967 1.83203Z"
          fill="white"
        />
        <path
          d="M7.55297 10.3877C7.41964 10.3877 7.29297 10.3344 7.19964 10.241L5.31297 8.35437C5.11964 8.16104 5.11964 7.84104 5.31297 7.64771C5.5063 7.45438 5.8263 7.45438 6.01964 7.64771L7.55297 9.18104L10.9796 5.75438C11.173 5.56104 11.493 5.56104 11.6863 5.75438C11.8796 5.94771 11.8796 6.26771 11.6863 6.46104L7.9063 10.241C7.81297 10.3344 7.6863 10.3877 7.55297 10.3877Z"
          fill="white"
        />
      </svg>
    );
    const daysLeft = Math.floor(diffDays);
    // text = `${daysLeft} day${daysLeft !== 1 ? "s" : ""} left`;
    text = (
      <>
        {daysLeft} day{daysLeft !== 1 ? "s" : ""} left
      </>
    );
  }

  return (
    <div className={` ${bg}`} title={dueDate.toLocaleString()}>
      {Icon}
      {/* <Icon size={16} /> */}
      <span>{text}</span>
    </div>
  );
}
